const selectTrackingGroups = state => state.data.trackingGroups

const TrackingGroupDataStoreSelectors = {
  trackingGroups: selectTrackingGroups
}

export default TrackingGroupDataStoreSelectors
